import React from 'react';

import CircularProgress from '~/components/core/Atomic/CircularProgress/CircularProgress';
import SkeletonLines from '~/components/core/Skeletons/SkeletonLines';
import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

// A blank page, filling in: the preview can take seconds to render, and a plain grey block reads as empty.
export const PreviewSkeleton: React.FC<{ label: string; className?: string }> = ({ label, className }) => (
  <div
    role="status"
    aria-label={label}
    className={cn(
      'flex h-[480px] w-full flex-col gap-24 rounded-lg border border-solid border-slate-300 bg-white px-32 py-24',
      className
    )}
  >
    <div className="flex items-center justify-center gap-8">
      <CircularProgress size={16} />
      <Text variant={Text.VARIANTS.SM} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        {label}
      </Text>
    </div>
    <SkeletonLines count={2} widths={['35%', '25%']} className="gap-8" />
    <SkeletonLines count={4} widths={['100%', '95%', '98%', '60%']} className="gap-8" lineClassName="h-12" />
    <SkeletonLines count={4} widths={['100%', '92%', '97%', '45%']} className="gap-8" lineClassName="h-12" />
  </div>
);
